import React from 'react';
import './AboutPage.css';
import aboutImg from './imagesAbout/aboutpage.png';

const AboutPage = () => {
  return (
    <div className='about-section'>
        <div className='page'> 
      <img src={aboutImg} alt=''/>
      </div>
    </div>
  )
}

export default AboutPage
